<script>
    import { query, search_terms, current_result, Filter } from "../stores";

    /**
     * [{
     *   label: "Fondo Primoli",
     *   field: "fond_string",
     *   value: "primoli"
     * }]
     * **/
    export let funds;
    export let funds_field;
    let selected;

    function onClick(label, value) {
        let f = new Filter(label, `${funds_field}:(${value})`);
        query.modify(selected, f);

        selected = f;
    }

    $: facets = $current_result.facets && $current_result.facets[funds_field]
        ? $current_result.facets[funds_field].values
        : [];
</script>

<div class="mb-3">
    {#if funds && funds.length}
        <label class="text-small">vedi in</label>
        {#each funds as {label, value} (funds_field + value)}
            <a on:click|preventDefault={() => onClick(label, value)}
               class:fund-selected={$search_terms.find(it => it.eq(`${funds_field}:(${value})`))}
               href="#" class="btn-filtro-fondo">
                {label} <span>{facets && facets.length ? facets.find(it => it.name === value).count : 0}</span>
            </a>
        {/each}
    {/if}
</div>

<style>
    .fund-selected {
        color: #EF4136;
        text-decoration: none;
    }
</style>